
export function agruparAcessosPorEntidade(acessos) {
  const agrupados = new Map();

  _.forEach(acessos, (acesso) => {
    const entidade = acesso.values.entity;
    const contextoPrincipal = isContextoPrincipal(acesso.values);
    const atual = agrupados.get(entidade);

    if (!atual || (contextoPrincipal && !atual.contextoPrincipal)) {
      agrupados.set(entidade, {
        entidade,
        context: acesso.context,
        contextoPrincipal
      });
    }
  });

  return Array.from(agrupados.values()).map(({ entidade, context }) => ({ entidade, context }));
}

export function isContextoPrincipal(values) {
  if (!values) return false;
  const keys = Object.keys(values);
  const hasDatabase = keys.includes('database');
  const hasEntity = keys.includes('entity');
  const extraKeys = keys.filter(key => key !== 'database' && key !== 'entity');
  return hasDatabase && hasEntity && extraKeys.length === 0;
}

export function filterAcessosPorSistema(acessos, sistema) {
  const entidades = _.filter(acessos, (acesso) => {
    return acesso.system === sistema;
  });
  return _.map(entidades, (acesso) => {
    return {
      database: acesso.values.database,
      entidade: acesso.values.entity,
      technical: acesso.technical,
      admin: acesso.admin
    };
  });
}

export function atribuirNomesEntidades(userAccountsService) {
  return (entidadesWrapper) => {
    const ids = _.map(entidadesWrapper, wrapper => wrapper.entidade);
    return userAccountsService.entitiesInfo(ids).then((infos) => {
      _.forEach(entidadesWrapper, (wrapper) => {
        wrapper.nome = _.find(infos, info => parseInt(wrapper.entidade, 10) === info.id).name;
      });
      return entidadesWrapper;
    });
  };
}

export function encodeIdSistemas(sistemas) {
  if (!sistemas) return;

  sistemas.forEach((sistema) => {
    sistema.encodedId = btoa(sistema.id);
  });
  return sistemas;
}

export function atribuirIcones(sistemas) {
  if (!sistemas) return;

  sistemas.forEach((sistema) => {
    sistema.icone = (_.find(propriedades, { id: sistema.id }) || propriedadeDefault).icone;
  });
  return sistemas;
}
